import React, {Fragment} from 'react';
import '../../css/mapstyle.css';
import InputSlider from '../InputSlider/InputSlider';
import Select, { components } from 'react-select';

class Colorpalettes extends React.Component {
   PopulateColors = () => {
        var nodes = this.props.nodes
        var palette = this.props.palette
        var customPalette = this.props.customPalette
        // TODO: rewrite Colorpalettes to work with custom user-defined colors instead of CSS presets
        /*
        if(customPalette != null) {
            console.log("custom palette color to render in legend: ", customPalette[nodes]);
        } else {
            // no custom palette for preset dropdown
            console.log("custom palette is null");
        }
        */
        let colors = ""
        switch (nodes) {
            case 0:
                colors = "clor-box c-0"
                break;
            case 1:
                colors = "clor-box c-1"
                break;
            case 2:
                colors = "clor-box c-2"
                break;
            case 3:
                colors = "clor-box c-3"
                break;
            case 4:
                colors = "clor-box c-4"
                break;
            case 5:
                colors = "clor-box c-5"
                break;
            case 6:
                colors = "clor-box c-6"
                break;
            default:
                colors = "clor-box c-7"
        }
        return colors + " pal-" + palette;
    }


    render() {
        return (
            <span className={this.PopulateColors()}></span>
        )
    }

}


class Cross extends React.Component {

    removeLayerCaller = () => {
        var nodes = this.props.nodes
        this.props.removeLayer(nodes)

    }

    render() {
        return (
            <span className="map-slct-icon">
                <img onClick={this.removeLayerCaller} alt="" src={require('../../images/tagCross.svg')}/>
            </span>
        )
    }

}

class Checkbox extends React.Component {

    UpdateMapCaller = () => {
        var nodes = this.props.nodes
        this.props.updateMapCaller(nodes)
    };

    render() {
        return (

            <input type="checkbox" id={this.props.id} onClick={this.UpdateMapCaller}
                   defaultChecked={this.props.checked ? true : false}/>
        )
    }

}

class Geog extends React.Component {
    GetOptionValue = (e) => {
        var innernode = e.target.value
        this.props.handleMapLayerGeographyChanged(innernode)
    }

    render() {
        let optionsList = this.props.nodes.node.dataDictionaryVariable.searchableindicatorSet.edges;
        const options = Array.from(new Set(optionsList.map(innernode => innernode.node.geographicUnit.name)))
            .map(name => {
                return {name: name, value: optionsList.find(s => s.node.geographicUnit.name === name).node.geographicUnit.summaryLevelCode};
            })

        var selectedValue = this.props.summaryLevelCode;
        for (var i = 0; i < options.length; i++) {
            if (options[i].value === this.props.summaryLevelCode) {
                selectedValue = options[i].value;
                break;
            }
        }
        return (

            <div className="county-box">
                <span>Change Geography:</span>
                <select className="select-dropdown" onChange={this.GetOptionValue} value={selectedValue?selectedValue:''}>
                    {options.map((innernode, j) => (
                        <option key={j} value={innernode.value}>{innernode.name}</option>
                    ))}
                </select>
            </div>
        )
    }

}

class PaletteDropDown extends React.Component {
    GetOptionValue = (e) => {
        const palette = e.value;
        this.props.onMapLayerPaletteChanged(this.props.indicatorId, palette)
    }

    formatOptionLabel = ({ value, label }) => {
        let palette = [];
        for (let i = 4; i > 0; i--) {
            palette.push(
                <Colorpalettes key={i} palette={Number(value)}
                               nodes={Number(i)}/>
            )
        }
        return (
            <div style={{ display: "flex" }}>
                {palette}
            </div>
        );
    }

    Menu = props => {
        return (
            <Fragment>
                <components.Menu {...props}>{props.children}</components.Menu>
            </Fragment>
        );
    };

    render() {
        let options = [
            {value: "0", label: "0"},
            {value: "1", label: "1"},
            {value: "2", label: "2"},
            {value: "3", label: "3"},
            {value: "4", label: "4"},
            {value: "5", label: "5"}];

        const customStyles = {
            control: (provided, state) => ({
                ...provided,
                minHeight: "28px",
                height: "28px",
                border: "1px solid #e3e3e3"
            }),
            menu: (provided, state) => ({
                ...provided,
                width: "100px;"
            }),
            valueContainer: base => ({
                ...base,
                position: "unset"
            }),
            dropdownIndicator: base => ({
                ...base,
                paddingTop: "4px"
            }),
        }
        var selectedValue = options[0];
        for (var i = 0; i < options.length; i++) {
            if (options[i].value == this.props.palette) {
                selectedValue = options[i];
                break;
            }
        }
        return (
            <div className="county-box">
                <span className="edit-color-theme-text">Edit Color Theme:</span>
                <div className="select-dropdown">
                    <Select defaultValue={selectedValue}
                            formatOptionLabel={this.formatOptionLabel}
                            components={this.Menu}
                            styles={customStyles}
                            onChange={this.GetOptionValue}
                            isSearchable={false}
                            options={options.reverse()} />
                </div>
            </div>
        )
    }
}

class YearDropdown extends React.Component {
    GetOptionValue = (e) => {

        var innernode = e.target.value
        this.props.handleMapLayerYearChanged(innernode)
    }

    render() {
        let options = this.props.nodes.node.dataDictionaryVariable.searchableindicatorSet.edges;
        options = [...new Set(options.map((innernode, j) => {
            if (innernode.node.startYear === innernode.node.endYear) {
                return innernode.node.startYear;
            } else {
                return innernode.node.startYear + " - " + innernode.node.endYear;
            }
        }))];
        var selectedValue = this.props.year;
        for (var i = 0; i < options.length; i++) {
            if (options[i] === this.props.year) {
                selectedValue = options[i];
                break;
            }
        }
        return (

            <div className="county-box">
                <span>Change Year:</span>
                <select className="select-dropdown" onChange={this.GetOptionValue} value={selectedValue?selectedValue:''}>
                    {options.map((innernode, j) => (
                        <option key={j} value={innernode}>{innernode}</option>
                    ))}
                </select>
            </div>
        )
    }

}

export class Layer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            apidata: props.indicatordata,
            varIndicatorid: "",
            isLayerVisible: true,
            visibleAttribute: true,
            summaryLevelCode: null,
            yearCombination: null,
        }
    }

    updateMapCaller = (indicatorData) => {
        this.props.handlecheckedIndicators(indicatorData.node.id)
    }


    removeLayer = (indicatorData) => {

        var indicatorid = indicatorData.node.id

        this.props.routeIndicatorId(indicatorid)


    }

    indicatorDetailTogggler = () => {
        this.props.closePopups();
        this.setState((prevState) => {
            return {visibleIndicatorDetail: !prevState.visibleIndicatorDetail};
        });
    }

    handleDataInfoPopup = (indicatorId) => {
        return () => {
            this.props.onDataInfoPopup(indicatorId);
        }
    }

    handleMapLayerYearChanged = (year, nodes) => {
        this.setState({yearCombination: year})
        this.handleMapLayerChanged(this.state.summaryLevelCode, year, nodes);
    }

    handleMapLayerGeographyChanged = (summaryLevelCode, nodes) => {
        this.setState({summaryLevelCode})
        this.handleMapLayerChanged(summaryLevelCode, this.state.yearCombination, nodes);
    }

    handleMapLayerChanged = (summaryLevelCode, year, nodes) => {
        nodes.node.dataDictionaryVariable.searchableindicatorSet.edges.map((innerNode, i) => {
            const years = String(year).indexOf("-") > -1 ? year.trim().split(" - ") : [year, year];
            const {node} = innerNode;

            if (summaryLevelCode === node.geographicUnit.summaryLevelCode &&
                (years.length === 2 && Number(years[0]) === node.startYear && Number(years[1]) === node.endYear)) {
                const updatefield = {
                    oldIndicatorId: this.props.indicatorid,
                    newIndicatorId: innerNode.node.id,
                    newSummaryLevelCode: innerNode.node.geographicUnit.summaryLevelCode
                }
                this.props.handleMapLayerGeographyChanged(updatefield.oldIndicatorId, updatefield.newIndicatorId, updatefield.newSummaryLevelCode)
            }
        })

    }

    componentDidMount() {
        this.props.indicatordata.indicatorMapLayer.indicators.edges.map((nodes, i) => {
                nodes.node.dataDictionaryVariable.searchableindicatorSet.edges.map((innerNode, i) => {
                    if (this.props.indicatorid === innerNode.node.id) {
                        let year = innerNode.node.startYear;
                        if (innerNode.node.startYear !== innerNode.node.endYear) {
                            year = innerNode.node.startYear + " - " + innerNode.node.endYear;
                        }
                        this.setState({summaryLevelCode: innerNode.node.geographicUnit.summaryLevelCode, yearCombination: year})
                    }
                })
        })
    }

    render() {
        const { summaryLevelCode, yearCombination } = this.state;
        var legendImage = null;
        if(this.props.bivariate && this.props.indicatordata != null)
        {
            const indicatorIds = this.props.indicatorid.split(",");
            if(indicatorIds[0] == "U2VhcmNoYWJsZUluZGljYXRvck5vZGU6MzUwMg==") {
                legendImage = "https://www.broadstreet.io/images/bivariate-map-legend-covid-deaths.png";
            } else {
                legendImage = "https://www.broadstreet.io/images/bivariate-map-legend-covid-cases.png";
            }
        }
        return (
            <div className="mapstyle-api"
                 style={{display: this.props.isMapLayersVisible === true && this.props.globallyVisible === true ? 'block' : 'none'}}>
                <form className="map-hidefilter add-new-data">
                    {this.props.bivariate === true && 
                    <img src={legendImage} height={230} />
                    }
                
                    <div className="checkbox-new-list">
                        <div/>
                        <div className="add-map-wrapper">
                            {this.props.indicatordata != null &&
                            this.props.indicatordata.indicatorMapLayer.indicators.edges.map((nodes, i) => {
                                return (
                                    <div className={this.props.bivariate === true ? "form-group p-1 m-0" : "form-group"} key={i}>
                                        <div className="map-sel-title grey">
                                        {!this.props.bivariate &&
                                            <Checkbox checked={this.props.isIndicatorChecked}
                                                      updateMapCaller={this.updateMapCaller}
                                                      nodes={nodes}
                                                      id={nodes.node.indicatorNamePlaintext}
                                                      indicatorDetailTogggler={this.indicatorDetailTogggler}
                                            />
                                        }
                                        {!this.props.bivariate &&
                                            <label htmlFor={nodes.node.indicatorNamePlaintext}>
                                            </label>
                                        }
                                            <span className="map-add-chat-txt"
                                                  onClick={this.handleDataInfoPopup(nodes.node.id)}>
                                                {nodes.node.indicatorNamePlaintext}
                                                <strong className="open-info-poup">
                                                    <img src={require('../../images/iconInfoDark.svg')}/>
                                                </strong>
                                        </span>
                                        {this.props.embedded !== true &&
                                            <Cross removeLayer={this.removeLayer} nodes={nodes}
                                                   routeIndicatorId={this.props.routeIndicatorId}/>
                                        }
                                        </div>
                                        {this.props.isIndicatorChecked === true ?
                                            <div className="open-list-checkbox">
                                                <ul>
                                                    {nodes.node.mapLegend && nodes.node.mapLegend.edges.map((nodes, j) => (
                                                        <li key={j}>
                                                            <Colorpalettes palette={this.props.palette}
                                                                           customPalette={this.props.customPalette}
                                                                           nodes={nodes.node.quantile}/>
                                                            {nodes.node.legendText}
                                                        </li>
                                                    ))}
                                                </ul>
                                                {this.props.embedded !== true &&
                                                <Geog
                                                    handleMapLayerGeographyChanged={(summaryLevelCode) => this.handleMapLayerGeographyChanged(summaryLevelCode, nodes)}
                                                    nodes={nodes}
                                                    indicatorId={nodes.node.id}
                                                    summaryLevelCode={summaryLevelCode}
                                                />
                                                }
                                                {this.props.embedded !== true &&
                                                <YearDropdown
                                                    nodes={nodes}
                                                    indicatorId={nodes.node.id}
                                                    handleMapLayerYearChanged={(year) => this.handleMapLayerYearChanged(year, nodes)}
                                                    year={yearCombination}
                                                />
                                                }
                                                {!this.props.bivariate &&
                                                <div className="county-box">
                                                    <span className="transparency-text">Adjust Transparency:</span>
                                                    <div className='select-dropdown'>
                                                        <InputSlider
                                                            onMapLayerOpacityChanged={this.props.onMapLayerOpacityChanged}
                                                            indicatorId={nodes.node.id} opacity={this.props.opacity}
                                                        />
                                                    </div>
                                                </div>
                                                }
                                                {this.props.embedded !== true &&
                                                <PaletteDropDown
                                                    onMapLayerPaletteChanged={this.props.onMapLayerPaletteChanged}
                                                    palette={this.props.palette}
                                                    indicatorId={nodes.node.id}
                                                />
                                                }
                                            </div>
                                            : null}
                                    </div>
                                )
                            })}
                        </div>
                        {this.props.bivariate &&
                        <div className="county-box">
                            <span className="transparency-text">Adjust Transparency:</span>
                            <div className='select-dropdown'>
                                <InputSlider
                                    onMapLayerOpacityChanged={this.props.onMapLayerOpacityChanged}
                                    indicatorId={this.props.indicatorid.split(",")} opacity={this.props.opacity}
                                />
                            </div>
                        </div>
                        }
                    </div>
                </form>
            </div>
        )
    }
}


export class MapLayers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMaplayerCheckBoxesVisible: true,
            indicatorid: "",
            indicatordata: props.indicatordata,
            scrollHeight: 0
        }
    }

    onSavedata = () => {
        this.props.handleSelectIndicator()
    };

    onToggle = () => {
        this.setState((prevState) => { return {isMaplayerCheckBoxesVisible: !prevState.isMaplayerCheckBoxesVisible} });
    }
    
    componentDidUpdate(prevProps, prevState) {
        if (this.mapLayers.scrollHeight !== prevState.scrollHeight) {
            this.setState({scrollHeight: this.mapLayers.scrollHeight})
            this.props.mapLayersUpdate(this.mapLayers.scrollHeight)
        }

    };

    render() {
        const {indicatorIdArray} = this.props;
        //console.log("MapLayers indicatorIdArray", indicatorIdArray);
        return (
            <div className="map-popup-wraper"
                 style={{display: this.props.isMapLayersVisible === true && this.props.globallyVisible === true ? 'block' : 'none'}}>
                <div className="h-100">
                    <div className={"map-style-top " + (indicatorIdArray.length === 0 ? "bottom-radius" : "")}>
                        <span className="map-list-title">Map Layers</span>
                        {this.props.embedded == true ?
                            <div className="srch-list-add-wrap" onClick={this.onToggle}>
                                <span className="srch-list-add-txt">{this.state.isMaplayerCheckBoxesVisible === true ? "Hide" : "Show"}</span>
                            </div>
                        :
                            <div className="srch-list-add-wrap" onClick={this.onSavedata}>
                                <span className="srch-list-add-icon" />
                                <span className="srch-list-add-txt">Add Data</span>
                            </div>
                        }
                    </div>
                    <div className={this.state.isMaplayerCheckBoxesVisible === true && this.props.children != null && this.props.children.length > 0 ? "scrollMaplayers" : "scrollMaplayers d-none"} ref={me => this.mapLayers = me}>
                        <div className="serch-map-style-section">
                            {this.props.children}
                            {this.props.embedded !== true &&
                                <StyleLayer 
                                 globallyVisible={this.props.globallyVisible} 
                                 isMapLayersVisible={this.props.isMapLayersVisible} 
                                 updateMapStyleCallback={this.props.updateMapStyleCallback}
                                />
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


class StyleLayer extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                apidata: props.indicatordata,
                varIndicatorid: "",
                isLayerVisible: true,
                visibleAttribute: true,
                summaryLevelCode: null,
                yearCombination: null,
            }
        }

        updateMapCaller = (option) => {
            if(this.props.updateMapStyleCallback != undefined) {
                this.props.updateMapStyleCallback(option);
            }
            
        //this.props.handlecheckedIndicators(indicatorData.node.id)
    }

        indicatorDetailTogggler = () => {
            this.props.closePopups();
            this.setState((prevState) => {
                return {visibleIndicatorDetail: !prevState.visibleIndicatorDetail};
            });
        }

        componentDidMount() {
        }

        render() {
            const { summaryLevelCode, yearCombination } = this.state;
            return (
                <div className="mapstyle-api"
                     style={{display: this.props.globallyVisible === true ? 'block' : 'none'}}>
                <form className="map-hidefilter add-new-data">
                    <div className="checkbox-new-list">
                        <div><strong>Labels &amp; Boundaries</strong></div>
                        <div className="add-map-wrapper">
                                    <div className="form-group">
                                        <div className="map-sel-title grey">
                  <Checkbox checked={this.props.isCountyBoundariesChecked}
                    updateMapCaller={this.updateMapCaller}
                    nodes="countyoutlines"
                    id="countyoutlines"
                  />

          <label htmlFor="countyoutlines">
          </label>
          <span className="map-style-option-text"
                    >
                  County Boundaries
          </span>
         </div>
                                    </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        )
                                            }
}




// WEBPACK FOOTER //
// ./src/components/MapLayers/MapLayers.js